import { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../Context/AuthProvider";
import { addPrescription, getPrescription, updatePrescription } from "../API/PrescriptionApi";
import { Toast } from "bootstrap";
import { getAppointment } from "../API/AppointmentsApi";

function NewPrescription({appointmentId}) {
  //const errRef = useRef();
  const [errorMessage, setErrorMessage] = useState();

  const location = useLocation();
  const auth = useContext(AuthContext);
  const [mode, setMode] = useState();
  //const [currentPatient, setCurrentPatient] = useState();

  const [currentAppointment, setCurrentAppointment] = useState();

  const [medicines, setMedicines] = useState([]);
  const [tests, setTests] = useState([]);
  const [complaint, setComplaint] = useState();
  const [diagnosis, setDiagnosis] = useState();
  const [additionalNotes, setAdditionalNotes] = useState();
  const [followupDate, setFollowupDate] = useState();
  const [currentPrescriptionId, setCurrentPrescriptionId] = useState();
  const [currentPrescription, setCurrentPrescription] = useState();
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState();

  useEffect(() => {
    const loadAppointment = async () => {
      //alert(JSON.stringify(location?.state?.appointmentId));
      if(auth != null && appointmentId != null)
      {
        var result = await getAppointment(auth, appointmentId);
        //alert(JSON.stringify(result));
        if(result.isSuccess)
        {
          var appointment = result?.data;
          setCurrentAppointment(appointment);
        }
        else
        {
          setErrorMessage(result?.errorMessage);
        }
      }
    }

    const loadPrescription = async () => {
      if(auth != null && location?.state?.prescriptionId != null)
      {
        var result = await getPrescription(auth, location?.state?.prescriptionId);
        if(result.isSuccess)
        {
          var prescription = result?.data;
          setCurrentPrescription(prescription);
          setCurrentAppointment(prescription?.appointment)
          
          var detailedPrescriptionJson = JSON.parse(prescription?.detailedPrescription);

          setComplaint(detailedPrescriptionJson?.complaint);
          setDiagnosis(detailedPrescriptionJson?.diagnosis);
          setMedicines(detailedPrescriptionJson?.medicines);
          setTests(detailedPrescriptionJson?.tests);
          setAdditionalNotes(detailedPrescriptionJson?.additionalNotes);
          setFollowupDate(detailedPrescriptionJson?.followupDate);
        }
        else
        {
          setErrorMessage(result?.errorMessage);
        }
      }
      
    };
    setMode(location?.state?.mode);
    //setCurrentPatient(location?.state?.patient);
    setCurrentPrescriptionId(location?.state?.prescriptionId);
    if(location?.state?.prescriptionId)
    {
      //for editing a prescription. The appointment details will be loaded as part of prescription.
      loadPrescription();
    }
    else
    {
      //for new prescription appointment details are loaded.
      loadAppointment();
    }
  }, [auth, location?.state]);

  async function onSaveAsDraftPrescription() {
    newOrUpdatePrescription("Draft");
  }

  async function onSubmitPrescription() {
    if(await newOrUpdatePrescription("Final"))
    {
      navigate("/patientdetails", {state: currentAppointment?.patient?.id});
    }
  }

  async function newOrUpdatePrescription(status)
  {
    console.log("In newOrUpdatePrescription");
    var prescription = {};

    prescription.complaint = complaint;
    prescription.diagnosis = diagnosis;
    prescription.medicines = medicines;
    prescription.tests = tests;
    prescription.additionalNotes = additionalNotes;
    prescription.followupDate = followupDate;

    console.log(JSON.stringify(prescription));

    if (!currentPrescriptionId) {
      var result = await addPrescription(auth, prescription, currentAppointment?.id, status);
      console.log(JSON.stringify(result));
      if(result.isSuccess)
      {
        setCurrentPrescriptionId(result.data);
        //alert();
        //var toast = new Toast(document.getElementById("successToast"));
        setSuccessMessage("The prescription is created successfully.");
        return true;
      }
      else
      {
        setErrorMessage(result?.errorMessage?.data);
        return false;
      } 

    }
    else
    {
      var updateResult = await updatePrescription(auth, prescription, currentPrescriptionId, status);
      if(updateResult.isSuccess)
      {
        //setCurrentPrescriptionId(result.data);
        //var toast = new Toast(document.getElementById("successToast"));
        setSuccessMessage("The prescription is updated successfully.");
        return true;
      }
      else
      {
        setErrorMessage(result?.errorMessage?.data);
        return false;
      } 
    }
  }

  return (
    <div class="container">
    
      <div class="row align-content-center mt-4">
        <div class="col-4 justify-content-start">
          {/* <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link to="/appointmentshome">Appointments</Link>
              </li>
              <li class="breadcrumb-item">
                <Link to="/patientdetails" state={currentAppointment?.patient?.id}>
                  Patient Details
                </Link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {!currentPrescriptionId ? "New Prescription" : "Change Prescription"}
              </li>
            </ol>
          </nav> */}
        </div>
       
        <div class="col-4 d-flex justify-content-center g-0">
          <h4>{!currentPrescriptionId ? "New Prescription" : "Id: " + currentPrescription?.displayId}</h4>
        </div>
        <div class="col-3 d-flex justify-content-end g-0">
          <div class="row align-items-center">
            <div class="col-8 d-flex justify-content-end pb-2">
              <button
                class="btn btn-secondary"
                onClick={onSaveAsDraftPrescription}
              >
                Save As Draft
              </button>
            </div>
            <div class="col-4 d-flex justify-content-end pb-2 ">
              <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#submitPrescriptionModal">
                Submit
              </button>
            </div>
          </div>
        </div>
        <div class="col-1 d-flex justify-content-center g-0"></div>
      </div>
      {/* <div class="row justify-content-center align-items-center pb-5 pt-3">
        <p class="lead text-danger" ref={errRef}>
          {errorMessage}
        </p>
      </div> */}
      <div class="row justify-content-center align-items-center pb-5 pt-3 border">
        <div class="col-1      "></div>

        <div class="col-10 border rounded">
          <div class="row justify-content-center align-items-center p-1">
            <div class="col justify-content-center ">
              <div class="row">Patient Name: {currentAppointment?.patient?.firstName}</div>
              <div class="row">MRN: {currentAppointment?.patient?.mrn}</div>
              <div class="row">Age and Gender: 45 Years | {currentAppointment?.patient?.gender}</div>
            </div>
            <div class="col "></div>
            <div class="col ">
              <div class="row justify-content-end">Date: {new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString()}</div>
            </div>
          </div>
          <div class="row justify-content-center align-items-center mt-4 p-1">
            <h5>Patient's Complaints</h5>
          </div>
          <div class="row justify-content-center align-items-center p-1">
            <textarea
              class="span6 w-100 d-flex  border rounded"
              rows="5"
              placeholder="Write about patient's complaint."
              value={complaint}
              onChange={(e) => setComplaint(e.target.value)}
              readOnly={mode === "view"}
            ></textarea>
          </div>
          <div class="row justify-content-center align-items-center mt-4 p-1">
            <h5>Diagnosis Notes</h5>
          </div>
          <div class="row justify-content-center align-items-center p-1">
            <textarea
              class="span6 w-100 d-flex  border rounded"
              rows="5"
              placeholder="Write about your diagnosis."
              value={diagnosis}
              onChange={(e) => setDiagnosis(e.target.value)}
              readOnly={mode === "view"}
            ></textarea>
          </div>
          <div class="row justify-content-center align-items-center mt-4 p-1">
            <div class="col      ">
              <h5>Medicines</h5>
            </div>

            <div class="col d-flex justify-content-end">
              <button
                class="btn btn-primary"
                onClick={() =>
                  setMedicines([
                    ...medicines,
                    { serialNo: medicines.length + 1 },
                  ])
                }
              >
                <i class="bi bi-plus-lg"></i>
              </button>
            </div>
          </div>

          <div class="row justify-content-center align-items-center p-1">
            <table class="table" id="medicineList">
              <thead>
                <tr>
                  <th scope="col" class="col-1">
                    #
                  </th>
                  <th scope="col" class="col-3">
                    Medicine
                  </th>
                  <th scope="col" class="col-2">
                    Duration
                  </th>
                  <th scope="col" class="col-2">
                    Frequency
                  </th>
                  <th scope="col" class="col-3">
                    Instructions
                  </th>
                  <th scope="col" class="col-1">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {medicines &&
                  medicines.map((med) => (
                    <tr>
                      <th scope="row">{med.serialNo}</th>
                      <td>
                        <input
                          class="w-100"
                          type="text"
                          value={med.name}
                          onChange={(e) => {
                            var copiedMedicines = [...medicines];
                            var medIndexToBeUpdated = copiedMedicines.findIndex(
                              (m) => m.serialNo === med.serialNo
                            );
                            copiedMedicines[medIndexToBeUpdated].name =
                              e.target.value;
                            setMedicines(copiedMedicines);
                          }}
                          readOnly={mode === "view"}
                        ></input>
                      </td>
                      <td>
                        <input
                          class="w-100"
                          type="text"
                          value={med.duration}
                          onChange={(e) => {
                            var copiedMedicines = [...medicines];
                            var medIndexToBeUpdated = copiedMedicines.findIndex(
                              (m) => m.serialNo === med.serialNo
                            );
                            copiedMedicines[medIndexToBeUpdated].duration =
                              e.target.value;
                            setMedicines(copiedMedicines);
                          }}
                          readOnly={mode === "view"}
                        ></input>
                      </td>
                      <td>
                        <input
                          class="w-100"
                          type="text"
                          value={med.frequency}
                          onChange={(e) => {
                            var copiedMedicines = [...medicines];
                            var medIndexToBeUpdated = copiedMedicines.findIndex(
                              (m) => m.serialNo === med.serialNo
                            );
                            copiedMedicines[medIndexToBeUpdated].frequency =
                              e.target.value;
                            setMedicines(copiedMedicines);
                          }}
                          readOnly={mode === "view"}
                        ></input>
                      </td>
                      <td>
                        <textarea
                          class="w-100"
                          rows={2}
                          type="text"
                          value={med.instructions}
                          onChange={(e) => {
                            var copiedMedicines = [...medicines];
                            var medIndexToBeUpdated = copiedMedicines.findIndex(
                              (m) => m.serialNo === med.serialNo
                            );
                            copiedMedicines[medIndexToBeUpdated].instructions =
                              e.target.value;
                            setMedicines(copiedMedicines);
                          }}
                          readOnly={mode === "view"}
                        ></textarea>
                      </td>

                      <td>
                        <button
                          class="btn btn-secondary small p-1 ms-1"
                          onClick={() => {
                            const filteredMeds = medicines.filter(
                              (m) => m.serialNo !== med.serialNo
                            );

                            var count = 0;
                            const nextMeds = filteredMeds.map((m) => {
                              return { ...m, serialNo: ++count };
                            });
                            setMedicines(nextMeds);
                          }}
                        >
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div class="row justify-content-center align-items-center mt-4 p-1">
            <div class="col      ">
              <h5>Reccommended Tests</h5>
            </div>

            <div class="col d-flex justify-content-end">
              <button
                class="btn btn-primary"
                onClick={() =>
                  setTests([...tests, { serialNo: tests.length + 1 }])
                }
              >
                <i class="bi bi-plus-lg"></i>
              </button>
            </div>
          </div>
          <div class="row justify-content-center align-items-center p-1">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="col-1">
                    #
                  </th>
                  <th scope="col" class="col-3">
                    Test Name
                  </th>
                  <th scope="col" class="col-3">
                    Tentative Date of Test
                  </th>
                  <th scope="col" class="col-4">
                    Instructions
                  </th>
                  <th scope="col" class="col-1">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {tests &&
                  tests.map((test) => (
                    <tr>
                      <th scope="row">{test.serialNo}</th>
                      <td>
                        <input
                          class="w-100"
                          type="text"
                          value={test.name}
                          onChange={(e) => {
                            var copiedTests = [...tests];
                            var testIndexToBeUpdated = copiedTests.findIndex(
                              (t) => t.serialNo === test.serialNo
                            );
                            copiedTests[testIndexToBeUpdated].name =
                              e.target.value;
                            setTests(copiedTests);
                          }}
                          readOnly={mode === "view"}
                        ></input>
                      </td>
                      <td>
                        <input
                          class="w-100"
                          type="date"
                          value={test.toBeDoneOn}
                          onChange={(e) => {
                            var copiedTests = [...tests];
                            var testIndexToBeUpdated = copiedTests.findIndex(
                              (t) => t.serialNo === test.serialNo
                            );
                            copiedTests[testIndexToBeUpdated].toBeDoneOn =
                              e.target.value;
                            setTests(copiedTests);
                          }}
                          readOnly={mode === "view"}
                        ></input>
                      </td>
                      <td>
                        <textarea
                          class="w-100"
                          rows={2}
                          type="text"
                          value={test.instructions}
                          onChange={(e) => {
                            var copiedTests = [...tests];
                            var testIndexToBeUpdated = copiedTests.findIndex(
                              (t) => t.serialNo === test.serialNo
                            );
                            copiedTests[testIndexToBeUpdated].instructions =
                              e.target.value;
                            setTests(copiedTests);
                          }}
                        ></textarea>
                      </td>
                      <td>
                        <button
                          class="btn btn-secondary small p-1 ms-1"
                          onClick={() => {
                            const filteredTests = tests.filter(
                              (t) => t.serialNo !== test.serialNo
                            );

                            var count = 0;
                            const nextTests = filteredTests.map((t) => {
                              return { ...t, serialNo: ++count };
                            });
                            setTests(nextTests);
                          }}
                        >
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div class="row justify-content-center align-items-center mt-4 p-1">
            <h5>Additional Notes</h5>
          </div>
          <div class="row justify-content-center align-items-center p-1">
            <textarea
              class="span6 w-100 d-flex  border rounded"
              rows="5"
              value={additionalNotes}
              onChange={(e) => setAdditionalNotes(e.target.value)}
              readOnly={mode === "view"}
            ></textarea>
          </div>
          <div class="row align-items-center pb-2 pt-2">
            <div class="col-2">
              <h5>Follow Up Date</h5>
            </div>
            <div class="col-4">
              <input
                class="form-control border"
                type="date"
                readOnly={mode === "view"}
              ></input>
            </div>
          </div>
        </div>
        <div class="col-1"></div>
      </div>
      <div class="modal fade" tabindex="-1" id="submitPrescriptionModal" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Submit Prescription Confirmation</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <p>Are you sure you want to submit the prescription. You will not be able to change it and it will be shared with the patient.</p>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" class="btn btn-primary" data-bs-dismiss="modal" onClick={onSubmitPrescription}>
                Submit Prescription
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewPrescription;
